var _clipPath, _use, _clipPath2, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.152,
    xmlns: "http://www.w3.org/2000/svg",
    height: 17.137,
    id: "screenshot-738c4961-3268-8021-8007-7a168749d80f",
    viewBox: "-1413.576 2177.423 14.152 17.137",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d80f",
    style: {
      fill: "#000000"
    },
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d810"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d810"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1406.4959716796875,2177.431640625C-1407.590576171875,2177.431640625,-1408.62646484375,2177.85546875,-1409.4073486328125,2178.6142578125C-1410.1885986328125,2179.3740234375,-1410.613037109375,2180.392578125,-1410.613037109375,2181.4716796875C-1410.613037109375,2183.69921875,-1408.7623291015625,2185.50390625,-1406.4959716796875,2185.50390625L-1406.4959716796875,2185.50390625C-1405.4005126953125,2185.50390625,-1404.364990234375,2185.0810546875,-1403.583984375,2184.3212890625C-1402.8031005859375,2183.5615234375,-1402.3785400390625,2182.5419921875,-1402.3785400390625,2181.462890625C-1402.3785400390625,2179.236328125,-1404.229248046875,2177.4228515625,-1406.4959716796875,2177.4228515625Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1d8ad3ba-c440-8062-8007-83e9d37b1f94-738c4961-3268-8021-8007-7a168749d810",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-41505-738c4961-3268-8021-8007-7a168749d810-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-41505-738c4961-3268-8021-8007-7a168749d810-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-1406.4959716796875,2177.431640625C-1407.590576171875,2177.431640625,-1408.62646484375,2177.85546875,-1409.4073486328125,2178.6142578125C-1410.1885986328125,2179.3740234375,-1410.613037109375,2180.392578125,-1410.613037109375,2181.4716796875C-1410.613037109375,2183.69921875,-1408.7623291015625,2185.50390625,-1406.4959716796875,2185.50390625L-1406.4959716796875,2185.50390625C-1405.4005126953125,2185.50390625,-1404.364990234375,2185.0810546875,-1403.583984375,2184.3212890625C-1402.8031005859375,2183.5615234375,-1402.3785400390625,2182.5419921875,-1402.3785400390625,2181.462890625C-1402.3785400390625,2179.236328125,-1404.229248046875,2177.4228515625,-1406.4959716796875,2177.4228515625Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 3,
      stroke: "#794c8a",
      strokeOpacity: 1
    },
    id: "stroke-shape-render-41505-738c4961-3268-8021-8007-7a168749d810-0"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-41505-738c4961-3268-8021-8007-7a168749d810-0",
    clipPath: "url('#inner-stroke-render-41505-738c4961-3268-8021-8007-7a168749d810-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-738c4961-3268-8021-8007-7a168749d811"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-738c4961-3268-8021-8007-7a168749d811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1402.268310546875,2185.7197265625C-1402.5313720703125,2185.4599609375,-1402.9302978515625,2185.443359375,-1403.218994140625,2185.6767578125C-1403.2529296875,2185.7021484375,-1406.5296630859375,2188.318359375,-1409.577392578125,2185.6767578125C-1409.8572998046875,2185.4345703125,-1410.25634765625,2185.443359375,-1410.5279541015625,2185.693359375C-1410.64697265625,2185.8056640625,-1413.5076904296875,2188.4990234375,-1413.575439453125,2193.765625C-1413.575439453125,2193.97265625,-1413.4991455078125,2194.1796875,-1413.363525390625,2194.3271484375C-1413.2276611328125,2194.4736328125,-1413.0323486328125,2194.560546875,-1412.8370361328125,2194.560546875L-1400.162841796875,2194.560546875C-1399.7640380859375,2194.560546875,-1399.44140625,2194.22265625,-1399.4244384765625,2193.7998046875C-1399.4244384765625,2193.5927734375,-1399.297119140625,2188.5947265625,-1402.259765625,2185.7109375Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeMiterlimit: 10
    },
    id: "strokes-1d8ad3ba-c440-8062-8007-83e9d37b1f95-738c4961-3268-8021-8007-7a168749d811",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-41506-738c4961-3268-8021-8007-7a168749d811-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-41506-738c4961-3268-8021-8007-7a168749d811-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-1402.268310546875,2185.7197265625C-1402.5313720703125,2185.4599609375,-1402.9302978515625,2185.443359375,-1403.218994140625,2185.6767578125C-1403.2529296875,2185.7021484375,-1406.5296630859375,2188.318359375,-1409.577392578125,2185.6767578125C-1409.8572998046875,2185.4345703125,-1410.25634765625,2185.443359375,-1410.5279541015625,2185.693359375C-1410.64697265625,2185.8056640625,-1413.5076904296875,2188.4990234375,-1413.575439453125,2193.765625C-1413.575439453125,2193.97265625,-1413.4991455078125,2194.1796875,-1413.363525390625,2194.3271484375C-1413.2276611328125,2194.4736328125,-1413.0323486328125,2194.560546875,-1412.8370361328125,2194.560546875L-1400.162841796875,2194.560546875C-1399.7640380859375,2194.560546875,-1399.44140625,2194.22265625,-1399.4244384765625,2193.7998046875C-1399.4244384765625,2193.5927734375,-1399.297119140625,2188.5947265625,-1402.259765625,2185.7109375Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 3,
      stroke: "#794c8a",
      strokeOpacity: 1
    },
    id: "stroke-shape-render-41506-738c4961-3268-8021-8007-7a168749d811-0"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-41506-738c4961-3268-8021-8007-7a168749d811-0",
    clipPath: "url('#inner-stroke-render-41506-738c4961-3268-8021-8007-7a168749d811-0')"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.26041bb7817381a637ac5090cc78c754.svg";
export { ForwardRef as ReactComponent };